import React, { Component } from 'react'
import Papa from "papaparse";
export default class About extends Component {
    constructor(props) {
        super(props);
        this.state = {
          Loading: false,
            article2:[],
            emp:[],
         
        };
        this.getsheet = this.getsheet.bind(this);
      
      }

      getsheet() {
        Papa.parse("https://docs.google.com/spreadsheets/d/1SJ8LxWmaxKBTgDJLvfD9NZLctBT931x19--qH2yLxck/pub?output=csv", {
            download: true,
            header: true,
            complete: (results) => {
                this.setState({ emp :results.data });
            //  setData(results.data);
            },
          });

        //   const movies = Array.from(data);
        //   return (
        //     // TODO: Output data as HTML
        //   );
       

      }


    render() {
        console.log(this.state.emp)
        return (
            <div>
                <h1>About</h1>
                <button onClick={this.getsheet.bind(this)}>Button</button> 
            </div>
        )
    }
}
